import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { UserCountSingleCard } from "../userDetailModal/components/userCountSingleCard";
import {
  AllModeTotalUsers,
  MobileIcon,
  StudioPlatformIcon,
  WebPlatformIcon,
} from "icons";
import { UseApiCallForOldDashboardData } from "hooks/use-api-call-for-old-dashboard";
import { getAnalyticsBaseUrl } from "utils/helpers";
import styles from "./styles.module.scss";

export const UsersCountCards = () => {
  const [date, setDate] = useState(new Date());
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { data: usersRatio, isLoading: usersRatioLoading } =
    UseApiCallForOldDashboardData({
      url: "user_ratio",
      method: "POST",
      body: {},
    });

  const fetchData = async () => {
    setLoading(true);
    const payload = {
      date: moment(date).format("DD-MM-YYYY"),
    };
    try {
      const response = await axios.post(
        `${getAnalyticsBaseUrl()}/statistics`,
        payload,
        {
          headers: {
            Authorization:
              "bearer bde14d5ef15ef9f2189e1db876c004907ac857f85976f95d1e3effd350bf60e9",
          },
        }
      );

      setData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [date]);

  const dummyUsersArr = [
    {
      header: {
        label: "All Users",
        value: usersRatio?.totalUsers,
        icons: [AllModeTotalUsers],
      },
      paidAndFree: [
        {
          type: "paid",
          label: "Active Subscriptions",
          value: usersRatio?.paidUsers,
          color: "#16A665",
          percentage: "0%",
        },
        {
          type: "free",
          label: "Expired Subscriptions",
          value: usersRatio?.freeUsers,
          color: "#FBB900",
          percentage: "0%",
        },
      ],
    },
    {
      header: {
        label: "Trial",
        value: 0,
        icons: [MobileIcon],
      },
      paidAndFree: [
        {
          type: "paid",
          label: "Active Subscrciptions",
          value: 0,
          color: "#16A665",
          percentage: "0%",
        },
        {
          type: "free",
          label: "Expired Subscriptions",
          value: 0,
          color: "#FBB900",
          percentage: "0%",
        },
      ],
    },
    {
      header: {
        label: "Basic",
        value: 0,
        icons: [MobileIcon],
      },
      paidAndFree: [
        {
          type: "paid",
          label: "Active Subscrciptions",
          value: 0,
          color: "#16A665",
          percentage: "0%",
        },
        {
          type: "free",
          label: "Expired Subscriptions",
          value: 0,
          color: "#FBB900",
          percentage: "0%",
        },
      ],
    },
    {
      header: {
        label: "Standard",
        value: 0,
        icons: [MobileIcon, WebPlatformIcon],
      },
      paidAndFree: [
        {
          type: "paid",
          label: "Active Subscrciptions",
          value: 0,
          color: "#16A665",
          percentage: "0%",
        },
        {
          type: "free",
          label: "Expired Subscriptions",
          value: 0,
          color: "#FBB900",
          percentage: "0%",
        },
      ],
    },
    {
      header: {
        label: "Premium",
        value: 0,
        icons: [MobileIcon, WebPlatformIcon, StudioPlatformIcon],
      },
      paidAndFree: [
        {
          type: "paid",
          label: "Active Subscrciptions",
          value: 0,
          percentage: "0%",
          color: "#16A665",
        },
        {
          type: "free",
          label: "Expired Subscriptions",
          value: 0,
          percentage: "0%",
          color: "#FBB900",
        },
      ],
    },
  ];

  return (
    <div className={styles.usersRow}>
      {dummyUsersArr?.map((userItem) => {
        return (
          <UserCountSingleCard
            key={userItem.header.label}
            userItem={userItem}
          />
        );
      })}
    </div>
  );
};
